import { HttpStatusCode } from '@angular/common/http';
import { BackendErrorDto } from '../../models/dto/backend-error-dto';

export enum BackendErrorType {
  ALREADY_SENT = 'ALREADY_SENT', //maps to CaseClosedException
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  CLIENT_ERROR = 'CLIENT_ERROR',
  EMAIL_NOT_VERIFIED = 'UNVERIFIED_EMAIL',
  WRONG_MAIL_CODE = 'WRONG_MAIL_CODE',
}

enum CaseClosedReason {
  UNKNOWN = 'UNKNOWN',
  CASE_EXPIRED = 'CASE_EXPIRED',
  CREDITCARD_ORDERED = 'CREDITCARD_ORDERED',
}

export function parseBackendErrorResponse(error: BackendErrorDto | null, status: number): BackendErrorType {
  const errorMessage = error?.message ?? '';

  if (status == HttpStatusCode.BadRequest && errorMessage.includes('was already closed')) {
    if (error?.details === CaseClosedReason.CASE_EXPIRED || error?.details === CaseClosedReason.UNKNOWN) {
      return BackendErrorType.VERIFICATION_ERROR;
    } else {
      return BackendErrorType.ALREADY_SENT;
    }
  }

  if (status == HttpStatusCode.BadRequest && errorMessage.includes('Email verification not')) {
    return BackendErrorType.EMAIL_NOT_VERIFIED;
  }

  if (status == HttpStatusCode.BadRequest && errorMessage.includes('Invalid email verification code')) {
    return BackendErrorType.WRONG_MAIL_CODE;
  }

  if (status == HttpStatusCode.BadRequest && errorMessage.includes('The landingpage password is invalid')) {
    return BackendErrorType.VERIFICATION_ERROR;
  }

  if (
    status == HttpStatusCode.BadRequest &&
    errorMessage.includes('Case with personal access token') &&
    errorMessage.includes('does not exist')
  ) {
    return BackendErrorType.VERIFICATION_ERROR;
  }

  if (status >= 400 && status <= 499) {
    return BackendErrorType.CLIENT_ERROR;
  } else if (status >= 500 && status <= 599) {
    return BackendErrorType.SERVER_ERROR;
  }

  return BackendErrorType.VERIFICATION_ERROR;
}

/**
 * True when the errorInterceptor already handles this error centrally (navigates to the generic
 * error page). Call sites that don't bypass server errors must check this and not also
 * navigate/set their own state for it — doing so would race the interceptor's own redirect.
 */
export function isHandledByErrorInterceptor(error: unknown): boolean {
  return error instanceof Error && error.message === BackendErrorType.SERVER_ERROR;
}
